import React from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const ScatterPlot = ({ data }) => {
  // Prepare data: Convert date and time strings to timestamps
  const processedData = data.map((d) => ({
    ...d,
    date: new Date(d.date).getTime(), // Convert date to timestamp
    time: new Date(`1970-01-01T${d.time}:00Z`).getTime(), // Convert time to timestamp
  }));

  // Group data by incident type
  const groupedData = processedData.reduce((acc, d) => {
    acc[d.type] = acc[d.type] || [];
    acc[d.type].push(d);
    return acc;
  }, {});

  // Generate color mapping for different incident types
  const COLORS = [
    "#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#d45087",
    "#a05195", "#ff6361", "#58508d", "#003f5c", "#bc5090"
  ];

  const colorMapping = Object.keys(groupedData).reduce((acc, type, index) => {
    acc[type] = COLORS[index % COLORS.length];
    return acc;
  }, {});

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ScatterChart>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          type="number"
          dataKey="date"
          name="Date"
          domain={["auto", "auto"]}
          tickFormatter={(tick) => new Date(tick).toLocaleDateString()}
        />
        <YAxis
          type="number"
          dataKey="time"
          name="Time"
          domain={["auto", "auto"]}
          tickFormatter={(tick) => new Date(tick).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        />
        <Tooltip
          cursor={{ strokeDasharray: "3 3" }}
          labelFormatter={(label) => new Date(label).toLocaleDateString()}
          formatter={(value) => new Date(value).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        />
        <Legend />
        {Object.entries(groupedData).map(([type, incidents]) => (
          <Scatter
            key={type}
            name={type}
            data={incidents}
            fill={colorMapping[type]}
          />
        ))}
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default ScatterPlot;
